export function removeSearchParam(param) {
    const url = new URL(window.location.href);
    url.searchParams.delete(param);
    window.history.replaceState({}, "", url);
}
//# sourceMappingURL=removeSearchParams.js.map